import * as React from 'react';
// @tidal-export alias=./Meta

import { validateTidalLicense } from '@workwave-tidal/license-utils'

export type MetaProps = {
  title?: string
  searchTags?: string[]
  includeStories?: RegExp | string | string[]
  excludeStories?: RegExp | string | string[]
}

export function Meta(_: MetaProps) {
  return null
}

// #license-validation
validateTidalLicense()
